import { agileSuccess } from './modules/agileHelper';
import { ajaxCall } from './modules/ajax';
import { expandSection } from './modules/collapse';

export function genericAgileListeners() {
    document.querySelectorAll('.agile-form').forEach((agileForm) => {
        const dialog = agileForm.querySelector('.agile-form-dialog');
        genericAgileAction(
            agileForm,
            () => {
                dialog.innerHTML = 'Bedankt voor het invullen!';
                // if (button) {
                //   button.querySelector("span").classList.remove("opacity-0");
                //   button.querySelector("img").classList.add("hidden");
                // }
            },
            () => {}
        );
    });
}

export function postGenericAgile(mail, name = '', company = '', tags, callbackSuccess, callbackFail) {
    var request = new XMLHttpRequest();
    request.open('POST', ajaxurl.ajax_url, true);
    request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
    request.onload = function () {
        if (this.status >= 200 && this.status < 400) {
            // If successful
            // console.log(request.responseText);
            callbackSuccess();
        } else {
            // If fail

            console.error(request);
            callbackFail();
        }
    };
    request.onerror = function () {
        // Connection error
        callbackFail();
    };
    request.send(
        'action=agileFormCalculator&contact=' +
            encodeURIComponent(
                JSON.stringify({
                    mail: mail,
                    first_name: firstName,
                    last_name: lastName,
                    company: company,
                    tags: tags,
                    form: 'generic',
                })
            )
    );
}

export function genericAgileAction(agileForm, callbackSuccess, callbackFail) {
    const button = agileForm.querySelector('.agile-form-button');
    if (button) {
        console.log(button);
        button.addEventListener('click', async (e) => {
            e.preventDefault();
            console.log('clicked');
            // Animate
            button.querySelector('span').classList.add('opacity-0');
            button.querySelector('img').classList.remove('hidden');

            // Validate
            const mail = agileForm.querySelector('input[type="email"]').value;
            const dialog = agileForm.querySelector('.agile-form-dialog');

            if (!validateEmail(mail)) {
                if (dialog) {
                    dialog.innerHTML = 'Vul een geldig emailadres in';
                }

                button.querySelector('span').classList.remove('opacity-0');
                button.querySelector('img').classList.add('hidden');
                return;
            }

            const name = agileForm.querySelector('input[name="naam"]').value;
            const company = agileForm.querySelector('input[name="bedrijfsnaam"]').value;

            if (mail == '' || name == '' || company == '') {
                dialog.innerHTML = 'Vul alle velden in';
                button.querySelector('span').classList.remove('opacity-0');
                button.querySelector('img').classList.add('hidden');
                return;
            }

            // Add to agile frontend
            if (typeof _agile !== 'undefined') {
                _agile.set_email(mail);
            }
            agileSuccess({
                email: mail,
            });

            let successCallback = () => {
                callbackSuccess();
            };

            let { data: responseData } = await ajaxCall('agileFormCalculator', {
                name,
                email_address: mail,
                company_name: company,
            });

            if (responseData.success) {
                dialog.innerHTML = 'Bedankt voor het invullen!';
                button.querySelector('span').classList.remove('opacity-0');
                button.querySelector('img').classList.add('hidden');

                const resultaten = document.getElementById('resultaten');
                expandSection(resultaten);

                if (typeof _agile !== 'undefined') {
                    _agile.set_email(mail);
                }
                agileSuccess({
                    email: mail,
                });
            }
        });
    }
}

function validateEmail(email) {
    var re =
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}
